import  { useState, useEffect } from 'react'
import { contactService } from '../../../services/contact.services'
import { 
  Container, Row, Col, 
  Form, Button, Card, 
  Alert, InputGroup, Spinner,
  Table, Badge, Modal,
  Pagination,
  ListGroup
} from 'react-bootstrap';

import { 
  FaEye, FaSearch,
  FaFilter, 
  FaUsers,
  FaPhone, 
  FaCalendarAlt, FaBuilding,
  FaEnvelope, FaClock, FaCheck,
  FaUser, FaCalendarDay, FaTrash,
  FaInfoCircle, FaHistory, 
  FaSort, FaSortUp, FaSortDown,
  FaExclamationTriangle
} from 'react-icons/fa';
import Layout from '../Dashbaord/Layout.js/Layout';

import 'react-toastify/dist/ReactToastify.css';
import { colors } from '../../../utils/Colors';
import { useAppData } from '../../../context';
import showToast from '../../../utils/Toast';
const Contact = () => {
  
  const { fetchCounts } = useAppData();

  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalContacts, setTotalContacts] = useState(0);
  const [unreadCount, setUnreadCount] = useState(0); 
  const [limit] = useState(10);
  
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  
  const [sortField, setSortField] = useState('createdAt');
  const [sortDirection, setSortDirection] = useState('desc');
  const [filterUnread, setFilterUnread] = useState(false);
  
  useEffect(() => {
    fetchContacts();
    fetchUnreadCount(); 
  }, [currentPage, searchTerm, sortField, sortDirection, filterUnread]);

  const fetchContacts = async () => {
    try {
      setLoading(true);
      const params = {
        page: currentPage,
        limit: limit,
        search: searchTerm,
        sortBy: sortField,
        sortOrder: sortDirection,
        isUnread: filterUnread || undefined
      };
      
      const response = await contactService.getAllContacts(params);
      
      if (response && response.data) {
        setContacts(response.data.contacts || response.data);
        setTotalPages(response.data.totalPages || 1);
        setTotalContacts(response.data.total || response.data.length || 0);
      }
      setError(null);
    } catch (err) {
      setError('Failed to load contacts. Please try again.');
      showToast.error('Failed to load contacts');
    
    } finally {
      setLoading(false);
    }
  };


  const fetchUnreadCount = async () => {
    try {
      const response = await contactService.getUnreadContactsCount();
      if (response && response.count !== undefined) {
        setUnreadCount(response.count);
      }
    } catch (err) {
  
     
      const unreadContacts = contacts.filter(contact => contact.isUnread);
      setUnreadCount(unreadContacts.length);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchTerm !== undefined) {
        setCurrentPage(1);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const handleViewContact = async (contact) => {
    console.log(contact);
    setSelectedContact(contact);
    setShowViewModal(true);
    
    if (contact.isUnread) {
      try {
        const res = await contactService.getContactById(contact._id);
        fetchContacts();
        fetchUnreadCount(); 
        fetchCounts(); 
      } catch (error) {
        showToast.error('Error marking as read:', error);
      }
    }
  };

  const handleDeleteClick = (contact) => {
    setSelectedContact(contact);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await contactService.deleteContactById(selectedContact._id);
      showToast.success('Contact deleted successfully');
      fetchContacts();
      fetchUnreadCount(); 
      fetchCounts(); 
    } catch (err) {
      showToast.error('Failed to delete contact');
     
    } finally {
      setShowDeleteModal(false);
      setSelectedContact(null);
    }
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
    setCurrentPage(1);
  };

  const getSortIcon = (field) => {
    if (sortField !== field) return <FaSort className="text-muted" />;
    return sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const renderPagination = () => {
    const items = [];
    const maxPagesToShow = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
    
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }
    
    items.push(
      <Pagination.Prev 
        key="prev" 
        onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
        disabled={currentPage === 1}
      />
    );
    
    if (startPage > 1) {
      items.push(
        <Pagination.Item key={1} onClick={() => setCurrentPage(1)}>
          1
        </Pagination.Item>
      );
      if (startPage > 2) {
        items.push(<Pagination.Ellipsis key="ellipsis-start" />);
      }
    }
    
    for (let page = startPage; page <= endPage; page++) {
      items.push(
        <Pagination.Item 
          key={page} 
          active={page === currentPage}
          onClick={() => setCurrentPage(page)}
        >
          {page}
        </Pagination.Item>
      );
    }
    
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        items.push(<Pagination.Ellipsis key="ellipsis-end" />);
      }
      items.push(
        <Pagination.Item 
          key={totalPages} 
          onClick={() => setCurrentPage(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }
    
    items.push(
      <Pagination.Next 
        key="next" 
        onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
        disabled={currentPage === totalPages}
      />
    );
    
    return items;
  };

  const StatsCard = ({ title, value, icon: Icon, color, subtitle }) => (
    <Card className="h-100 border-0 shadow-sm">
      <Card.Body className="d-flex align-items-center">
        <div className={`rounded-circle p-3 me-3 bg-${color}-subtle`}>
          <Icon className={`text-${color} fs-4`} />
        </div>
        <div>
          <h3 className="fw-bold mb-1">{value}</h3>
          <p className="text-muted mb-0">{title}</p>
          {subtitle && <small className="text-muted">{subtitle}</small>}
        </div>
      </Card.Body>
    </Card>
  );

 


  return (
    <Layout>
      <Container fluid className="py-4">
        <Row className="mb-4 align-items-center p-4 rounded-3" style={{ backgroundColor: colors.TABLE_HEADERS }}>
          <Col md={6}>
            <div>
              <h2 className="fw-bold mb-2 text-white">
                <FaCalendarAlt className="me-2" />
                Contacts Management
              </h2>
              <p className="text-white-50 mb-0">
                <FaUsers className="me-2" />
                Manage all contacts records and information
              </p>
            </div>
          </Col>
          
         
        </Row>

       
        <Row className="mb-4 g-3">
          <Col md={3}>
            <StatsCard 
              title="Total Contacts" 
              value={totalContacts}
              icon={FaUsers}
              color="primary"
            />
          </Col>
          <Col md={3}>
            <StatsCard 
              title="Unread Messages" 
              value={unreadCount} 
              icon={FaEnvelope}
              color="warning"
              subtitle="Require attention"
            />
          </Col>
          <Col md={3}>
            <StatsCard 
              title="Today's Contacts" 
              value={contacts.filter(c => {
                const today = new Date().toDateString();
                const contactDate = new Date(c.createdAt).toDateString();
                return contactDate === today;
              }).length}
              icon={FaCalendarDay}
              color="success"
            />
          </Col>
          <Col md={3}>
            <StatsCard 
              title="Active Filters" 
              value={filterUnread ? '1' : '0'}
              icon={FaFilter}
              color="info"
              subtitle={filterUnread ? 'Showing unread only' : 'No filters'}
            />
          </Col>
        </Row>

        {/* Search and Filter Section */}
        <Card className="mb-4 border-0 shadow-sm">
          <Card.Body>
            <Row className="align-items-center">
              <Col md={6}>
                <InputGroup>
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search contacts by name, email, phone, or message..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <Button 
                    variant="outline-secondary"
                    onClick={() => setSearchTerm('')}
                  >
                    Clear
                  </Button>
                </InputGroup>
              </Col>
              
              <Col md={6} className="mt-2 mt-md-0">
                <div className="d-flex flex-wrap gap-2 justify-content-end">
                  <Button
                    variant={filterUnread ? "warning" : "outline-secondary"}
                    onClick={() => setFilterUnread(!filterUnread)}
                    className="d-flex align-items-center"
                  >
                    <FaEnvelope className="me-2" />
                    {filterUnread ? 'Show All' : 'Unread Only'}
                  </Button>
                  
                  <Button
                    variant="outline-primary"
                    onClick={() => {
                      fetchContacts();
                      fetchUnreadCount();
                    }}
                    className="d-flex align-items-center"
                  >
                    Refresh
                  </Button>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Contacts Table */}
        <Card className="border-0 shadow-sm">
          <Card.Body className="p-0">
            {loading ? (
              <div className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2 text-muted">Loading contacts...</p>
              </div>
            ) : error ? (
              <Alert variant="danger" className="m-4">
                <FaExclamationTriangle className="me-2" />
                {error}
              </Alert>
            ) : contacts.length === 0 ? (
              <div className="text-center py-5">
                <FaUsers className="text-muted mb-3" size={48} />
                <h5 className="text-muted">No contacts found</h5>
                <p className="text-muted">
                  {searchTerm ? 'Try a different search term' : 'No contacts available'}
                </p>
              </div>
            ) : (
              <>
                <div className="table-responsive">
                  <Table hover className="mb-0">
                    <thead className="table-light">
                      <tr>
                        <th 
                          style={{ width: '5%', cursor: 'pointer' }}
                          onClick={() => handleSort('isUnread')}
                        >
                          <div className="d-flex align-items-center">
                            <span>Status</span>
                            <span className="ms-1">{getSortIcon('isUnread')}</span>
                          </div>
                        </th>
                        <th 
                          style={{ width: '20%', cursor: 'pointer' }}
                          onClick={() => handleSort('name')}
                        >
                          <div className="d-flex align-items-center">
                            <FaUser className="me-2" />
                            <span>Name</span>
                            <span className="ms-1">{getSortIcon('name')}</span>
                          </div>
                        </th>
                        <th 
                          style={{ width: '15%', cursor: 'pointer' }}
                          onClick={() => handleSort('email')}
                        >
                          <div className="d-flex align-items-center">
                            <FaEnvelope className="me-2" />
                            <span>Email</span>
                            <span className="ms-1">{getSortIcon('email')}</span>
                          </div>
                        </th>
                        <th 
                          style={{ width: '15%', cursor: 'pointer' }}
                          onClick={() => handleSort('phone')}
                        >
                          <div className="d-flex align-items-center">
                            <FaPhone className="me-2" />
                            <span>Phone</span>
                            <span className="ms-1">{getSortIcon('phone')}</span>
                          </div>
                        </th>
                        <th 
                          style={{ width: '20%', cursor: 'pointer' }}
                          onClick={() => handleSort('subject')}
                        >
                          <div className="d-flex align-items-center">
                            <FaInfoCircle className="me-2" />
                            <span>Subject</span>
                            <span className="ms-1">{getSortIcon('subject')}</span>
                          </div>
                        </th>
                        <th 
                          style={{ width: '15%', cursor: 'pointer' }}
                          onClick={() => handleSort('createdAt')}
                        >
                          <div className="d-flex align-items-center">
                            <FaCalendarAlt className="me-2" />
                            <span>Date</span>
                            <span className="ms-1">{getSortIcon('createdAt')}</span>
                          </div>
                        </th>
                        <th style={{ width: '10%' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contacts.map((contact) => (
                        <tr key={contact._id} className={contact.isUnread ? 'table-warning' : ''}>
                          <td>
                            {contact.isUnread ? (
                              <Badge bg="warning" className="rounded-pill px-3">
                                <FaClock className="me-1" /> Unread
                              </Badge>
                            ) : (
                              <Badge bg="success" className="rounded-pill px-3">
                                <FaCheck className="me-1" /> Read
                              </Badge>
                            )}
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="flex-shrink-0">
                                <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" 
                                     style={{ width: '32px', height: '32px' }}>
                                  {contact.name?.charAt(0)?.toUpperCase() || '?'}
                                </div>
                              </div>
                              <div className="flex-grow-1 ms-3">
                                <h6 className="mb-0">{contact.name || 'N/A'}</h6>
                                {contact.company && (
                                  <small className="text-muted">
                                    <FaBuilding className="me-1" />
                                    {contact.company}
                                  </small>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>
                            <a href={`mailto:${contact.email}`} className="text-decoration-none">
                              {contact.email || 'N/A'}
                            </a>
                          </td>
                          <td>
                            {contact.phone ? (
                              <a href={`tel:${contact.phone}`} className="text-decoration-none">
                                <FaPhone className="me-1" />
                                {contact.phone}
                              </a>
                            ) : 'N/A'}
                          </td>
                          <td>
                            <div className="text-truncate" style={{ maxWidth: '200px' }}>
                              {contact.message || 'No subject'}
                            </div>
                          </td>
                          <td>
                            <small className="text-muted">
                              {formatDate(contact.createdAt)}
                            </small>
                          </td>
                          <td>
                            <div className="d-flex gap-2">
                              <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => handleViewContact(contact)}
                                title="View Details"
                              >
                                <FaEye />
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => handleDeleteClick(contact)}
                                title="Delete Contact"
                              >
                                <FaTrash />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div className="d-flex justify-content-between align-items-center p-3 border-top">
                    <div className="text-muted">
                      Showing {(currentPage - 1) * limit + 1} to {Math.min(currentPage * limit, totalContacts)} of {totalContacts} contacts
                    </div>
                    <Pagination className="mb-0">
                      {renderPagination()}
                    </Pagination>
                  </div>
                )}
              </>
            )}
          </Card.Body>
        </Card>
      </Container>

      {/* View Contact Modal */}
      <Modal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton className="text-white" style={{backgroundColor: colors.TABLE_HEADERS}}>
          <Modal.Title>
            <FaUser className="me-2" />
            Contact Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedContact && (
            <div className="contact-details">
              <Row className="mb-4">
                <Col md={8}>
                  <h4 className="fw-bold mb-1">{selectedContact.name}</h4>
                  <p className="text-muted mb-2">
                    {selectedContact.company && (
                      <>
                        <FaBuilding className="me-2" />
                        {selectedContact.company}
                      </>
                    )}
                  </p>
                  <Badge bg={selectedContact.isUnread ? "warning" : "success"} className="mb-3">
                    {selectedContact.isUnread ? 'UNREAD' : 'READ'}
                  </Badge>
                </Col>
                <Col md={4} className="text-end">
                  <div className="text-muted">
                    <FaCalendarAlt className="me-1" />
                    {formatDate(selectedContact.createdAt)}
                  </div>
                </Col>
              </Row>

              <Row className="g-3 mb-4">
                <Col md={6}>
                  <Card className="h-100">
                    <Card.Body>
                      <h6 className="text-uppercase text-muted mb-3">
                        <FaEnvelope className="me-2" />
                        Contact Information
                      </h6>
                      <ListGroup variant="flush">
                        <ListGroup.Item className="d-flex align-items-center">
                          <FaEnvelope className="text-primary me-3" />
                          <div>
                            <strong>Email:</strong><br />
                            <a href={`mailto:${selectedContact.email}`} className="text-decoration-none">
                              {selectedContact.email}
                            </a>
                          </div>
                        </ListGroup.Item>
                        <ListGroup.Item className="d-flex align-items-center">
                          <FaPhone className="text-primary me-3" />
                          <div>
                            <strong>Phone:</strong><br />
                            {selectedContact.phone ? (
                              <a href={`tel:${selectedContact.phone}`} className="text-decoration-none">
                                {selectedContact.phone}
                              </a>
                            ) : 'N/A'}
                          </div>
                        </ListGroup.Item>
                      </ListGroup>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6}>
                  <Card className="h-100">
                    <Card.Body>
                      <h6 className="text-uppercase text-muted mb-3">
                        <FaInfoCircle className="me-2" />
                        Inquiry Details
                      </h6>
                      <ListGroup variant="flush">
                        <ListGroup.Item>
                          <strong>Subject:</strong><br />
                          {selectedContact.subject || 'No subject'}
                        </ListGroup.Item>
                        <ListGroup.Item>
                          <strong>Contact Method:</strong><br />
                          {selectedContact.contactMethod || 'Web Form'}
                        </ListGroup.Item>
                      </ListGroup>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              <Card>
                <Card.Body>
                  <h6 className="text-uppercase text-muted mb-3">
                    <FaHistory className="me-2" />
                    Message
                  </h6>
                  <div className="bg-light p-3 rounded">
                    {selectedContact.message || 'No message provided'}
                  </div>
                </Card.Body>
              </Card>

              {selectedContact.additionalInfo && (
                <Card className="mt-3">
                  <Card.Body>
                    <h6 className="text-uppercase text-muted mb-3">
                      <FaInfoCircle className="me-2" />
                      Additional Information
                    </h6>
                    <pre className="mb-0 text-muted" style={{ whiteSpace: 'pre-wrap' }}>
                      {JSON.stringify(selectedContact.additionalInfo, null, 2)}
                    </pre>
                  </Card.Body>
                </Card>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowViewModal(false)}>
            Close
          </Button>
          {selectedContact?.email && (
            <Button
              variant="primary"
              href={`mailto:${selectedContact.email}`}
            >
              <FaEnvelope className="me-2" />
              Reply via Email
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton className="bg-danger text-white">
          <Modal.Title>
            <FaExclamationTriangle className="me-2" />
            Confirm Deletion
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedContact && (
            <>
              <Alert variant="danger" className="d-flex align-items-center">
                <FaExclamationTriangle className="me-2 fs-4" />
                <div>
                  <strong>Warning:</strong> This action cannot be undone.
                </div>
              </Alert>
              <p>
                Are you sure you want to delete the contact from <strong>{selectedContact.name}</strong>?
              </p>
              <div className="bg-light p-3 rounded">
                <strong>Contact Details:</strong>
                <ul className="mb-0 mt-2">
                  <li>Name: {selectedContact.name}</li>
                  <li>Email: {selectedContact.email}</li>
                  <li>Subject: {selectedContact.subject || 'No subject'}</li>
                </ul>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            <FaTrash className="me-2" />
            Delete Contact
          </Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
};

export default Contact;